export default [
  // Main Page
  {
    path: 'sync-collections',
    name: 'website.gmc.sync-collections',
    component: () => import('@/views/website/gmc/sync-collections'),
  },
  {
    path: 'sync-collections/update/:id',
    name: 'website.gmc.sync-collections.update',
    component: () => import('@/views/website/gmc/sync-collections/Update'),
  },
  {
    path: 'sync-collections/create',
    name: 'website.gmc.sync-collections.create',
    component: () => import('@/views/website/gmc/sync-collections/Create'),
  },
];
